// commonChartConfig.ts

import Highcharts from 'highcharts';

interface BaseConfigOptions {
  title?: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
  yAxisMax?: number | null;
  yAxisMin?: number | null;
  tooltipFormatter?: Highcharts.TooltipFormatterCallbackFunction;
  plotLines?: Highcharts.YAxisPlotLinesOptions[];
  plotBands?: Highcharts.YAxisPlotBandsOptions[];
}

export const getBaseChartOptions = ({
  title = 'Default Title',
  xAxisTitle = 'Time',
  yAxisTitle = 'Value',
  yAxisMax = 100,
  yAxisMin = 0,
  tooltipFormatter,
  plotLines = [],
  plotBands = [],
}: BaseConfigOptions): Highcharts.Options => {
  return {
    chart: {
      type: 'line',
      zooming: {
        type: 'xy',
      },
      backgroundColor: '#fff',
      style: {
        fontFamily: 'Inter, sans-serif',
      },
    },
    time: {
      useUTC: false,
    },
    title: {
      text: title,
      style: {
        fontSize: '1.125rem',
      },
    },
    xAxis: {
      type: 'datetime',
      title: { text: xAxisTitle },
      labels: {
        rotation: -45,
      },
      dateTimeLabelFormats: {
        day: '%b %e, %Y',
        month: '%b %Y',
        year: '%Y',
      },
      gridLineColor: '#e5e7eb',
    },
    yAxis: {
      title: { text: yAxisTitle },
      max: yAxisMax,
      min: yAxisMin,
      plotLines,
      plotBands,
      gridLineColor: '#e5e7eb',
      gridZIndex: -1,
    },
    tooltip: {
      // shared: true,
      xDateFormat: '%Y-%m-%d %H:%M:%S',
      formatter: tooltipFormatter,
    },
    plotOptions: {
      line: {
        marker: { enabled: false },
        softThreshold: false,
      },
      arearange: {
        marker: { enabled: false },
      },
    },
    credits: { enabled: false },
  };
};
